<template>
  {{ count }}
  <template v-if="count === 1">{{ translation('course_count') }}</template>
  <template v-else-if="count > 1 && count < 5">{{ translation('course_count-2-4') }}</template>
  <template v-else>{{ translation('course_count-5-more') }}</template>
</template>

<script>
import codeBooksMixin from "@/mixins/codeBooksMixin";

export default {
  props: {
    count: {
      type: Number,
      required: true
    }
  },
  mixins: [codeBooksMixin],
}
</script>